import { useDebounce } from 'spectacle-ui-game-bridge-react';
import useDlogLoginFunnel, { DlogLoginFunnelColumns } from './useDlogLoginFunnel';

// Only columns passed on first render will be used; do not dynamically change passed columns
export default function useDebouncedDlogFunnel(columns: DlogLoginFunnelColumns) {
  const dlog = useDlogLoginFunnel();

  return useDebounce(
    () => {
      dlog(columns);
      // Don't pass columns to debounce deps array, because they should be statically passed and never change
    },
    [],
    10000, // debounce dupe logs <10sec apart
    {
      leading: true, // send first log immediately, don't wait for debounce timer
    }
  );
}
